<template>
  <b-row>
    <b-col>
      <h6 class="compo-heading">{{ $t("5005.address.address") }}</h6>
    </b-col>
  </b-row>
  <div class="details-card">
    <b-row>
      <b-col lg="12" md="12" sm="12" cols="12">
        <div class="field">
          <TextInput placeholder="" v-model="addressdetails.StreetName" @change="input"
            :label="$t('5005.address.streetname')" name="Street" id="Street" :required-icon="false"
            :rules="{ required: false }" />
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" md="12" sm="12" cols="12">
        <div class="field">
          <TextInput placeholder="" v-model="addressdetails.Landmark" @change="input"
            :label="$t('5005.address.landmark')" name="LandMark" id="LandMark" :rules="{}" />
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" md="12" sm="12" cols="12" class="field">
        <div class="field">
          <TextInput placeholder="" v-model="addressdetails.Address" @change="input" :label="$t('5005.address.address')"
            name="Address" id="Address" :required-icon="false" :rules="{ required: false }" />
        </div>
      </b-col>

      <b-col lg="6" md="6" sm="6" cols="12">
        <div class="field">
          <CustomDropDown v-model="addressdetails.Country" :items="country.countryoption"
            @update:modelValue="CountryChange" :label="$t('5005.address.country')" name="Country" id="Country"
            :required-icon="true" :rules="{ required: true }" />
        </div>
      </b-col>

      <b-col lg="6" md="6" sm="6" cols="12">
        <div class="field">
          <CustomDropDown v-model="addressdetails.State" :items="state.stateoption" @update:modelValue="StateChange"
            :label="$t('5005.address.state')" name="State" id="State" :required-icon="true"
            :rules="{ required: true }" />
        </div>
      </b-col>

      <b-col lg="6" md="6" sm="6" cols="12">
        <div class="field">
          <CustomDropDown v-model="addressdetails.City" :items="city.cityoption" :label="$t('5005.address.city')"
            name="City" id="City" :required-icon="true" :rules="{ required: true }" />
        </div>
      </b-col>

      <b-col lg="6" md="" sm="6" cols="6" class="field">
        <div class="field">
          <TextInput placeholder="" v-model="addressdetails.Pin" @change="input" :label="$t('5005.address.pincode')"
            name="Pincode" id="Pincode" :required-icon="true" :rules="{ required: true, numeric: true }" />
        </div>
      </b-col>
    </b-row>
    <b-row v-if="
      addressdetails.Country != 101 && addressdetails.Country != undefined
    ">
      <b-col lg="6" md="6" sm="6" cols="12">
        <div class="field">
          <TextInput placeholder="" v-model="addressdetails.SwiftCode" @change="input" label="Swift Code"
            name="SwiftCode" id="SwiftCode" :required-icon="false" :rules="{ required: false }" />
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="6" cols="12">
        <div class="field">
          <TextInput placeholder="" v-model="addressdetails.IecCode" @change="input" label="IEC Code" name="IecCode"
            id="IecCode" :required-icon="false" :rules="{ required: false }" />
        </div>
      </b-col>

      <b-col lg="6" md="6" sm="6" cols="12" class="field mt-2">
        <label>CDSC Approval</label>
        <div class="my-2 d-flex gap-4">
          <div class="d-flex">
            <RadioButton v-model="addressdetails.CdscApproval" inputId="Yes" name="Yes" :value="1" />
            <label for="Yes" class="ms-2">Yes</label>
          </div>
          <div class="d-flex">
            <RadioButton v-model="addressdetails.CdscApproval" inputId="ingredient1" name="No" :value="0" />
            <label for="No" class="ms-2">No</label>
          </div>
        </div>
      </b-col>
      <b-col lg="6" md="6" sm="6" cols="12">
        <div class="field">
          <CustomMultiSelect placeholder="Select Tag Unit" label="Select Tag Unit" v-model="addressdetails.TagUnit"
            :items="List" @update:modelValue="loadStoreList" ref="multiRef" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, toRefs, onMounted, watch } from "vue";
import service from "../../Service/CommonService";
import TextInput from "../../../../components/FormComponents/TextInput.vue";
import CustomDropDown from "../../../../components/FormComponents/Dropdown.vue";
import commonservice from "../../Service/StoreService";
import CustomMultiSelect from "../../../../components/FormComponents/MultiSelectDropdown.vue";
import { useForm } from "vee-validate";

export default defineComponent({
  components: {
    TextInput,
    CustomDropDown,
    CustomMultiSelect,
  },
  props: {
    Id: {
      type: Number,
      default: "",
    },
    value: {},
  },

  methods: {},

  setup(props, { emit }) {
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let Hospital_Id = session.HospitalCode;
    debugger;
    let addressdetails = reactive({
      StreetName: "",
      Landmark: "",
      Address: "",
      City: ref(),
      State: ref(),
      Country: ref(),
      Pin: "",
      SwiftCode: "",
      IecCode: "",
      CdscApproval: ref(),
      TagUnit: [],
    });
    // const { handleSubmit, errors, resetForm, resetField } = useForm();
    // const resetNameField = (Fieldname) => {
    //   resetField(Fieldname); // Resets the name field to its initial value
    // };


    let List = ref();
    onMounted(() => {
      ctrydropdownapi();
      Object.assign(addressdetails, props.value);
      input();
      loadStoreList();
    });

    watch(
      () => addressdetails.Country,
      () => {
        onCountryChange();
      }
    );
    watch(
      () => addressdetails.State,
      () => {
        onStateChange();
      }
    );
    function input() {
      debugger;
      console.log(addressdetails);
      emit("update:modelValue", addressdetails);
    }
    const country = ref({
      countryid: null,
      countryoption: [],
    });
    async function ctrydropdownapi() {
      debugger;
      const objval = ref({
        Dml_Indicator: "C",
      });
      const response = await service.LoadCountry();
      let data = response["result"];
      console.log("coutry", data);
      country.value.countryoption = data.map((item) => {
        item.name = item.Name;
        item.value = item.ID;
        return item;
      });
    }

    //Country On Change

    async function onCountryChange() {
      const data = ref({
        Dml_Indicator: "S",
        country_id: addressdetails.Country,
      });
      const response = await service.LoadState(addressdetails.Country);

      state.value.stateoption = response["result"].map((item) => {
        item.name = item.Name;
        item.value = item.ID;
        return item;
      });
      input();
    }
    async function loadStoreList() {
      debugger;
      const result = await commonservice.getStoreList(HospitalId, BranchId);
      console.log(result);
      List.value = result["result"]
        .filter(
          (i1) =>
            i1.IsActive == true &&
            i1.HospitalId == HospitalId &&
            i1.BranchId == BranchId
        )
        .map((item) => {
          item.name = item.Name;
          item.value = item.Id;
          return item;
        });
      // alert(JSON.stringify(List.value))
    }
    const state = ref({
      stateid: null,
      stateoption: [],
    });

    const city = ref({
      cityid: null,
      cityoption: [],
    });
    //State On Change
    async function onStateChange() {

      const data = ref({
        Dml_Indicator: "CI",
        state_id: addressdetails.State,
      });
      const response = await service.LoadCity(addressdetails.State);
      city.value.cityoption = response["result"].map((item) => {
        item.name = item.Name;
        item.value = item.ID;
        return item;
      });
      input();
    }
    function CountryChange() {
      addressdetails.State = ref()
      state.value.stateoption = []
    }
    function StateChange() {
      addressdetails.City = ref()
      city.value.cityoption = []

    }


    return {
      loadStoreList,
      List,
      input,
      country,
      state,
      city,
      onCountryChange,
      onStateChange,
      addressdetails,
      CountryChange,
      StateChange
    };
  },

  created() { },
});
</script>
